/* eslint-disable quote-props */
/* eslint-disable max-len */

export default {
  // Order
  asap: 'Schnellstmöglich',
  empty_input: 'Bitte füllen Sie dieses Feld aus.',
  empty_dropdown: 'Bitte wählen Sie eine Option aus.',
  empty_radio: 'Bitte wählen Sie eine Option aus.',
  empty_checkbox: 'Bitte bestätigen Sie dieses Feld um die Anfrage zu senden.',
  consumption_per_year: 'Bitte geben Sie Ihren Jahresverbrauch an.',
  consumption_amount: 'Bitte geben Sie eine Zahl zwischen {min} und {max} an.',
  consumption_amount_min: 'Mindestbestellmenge {min} kWh.',
  consumption_amount_min_rlm: 'Bitte geben Sie einen Wert ab {min} kWh an.',
  postal_code: 'Bitte geben Sie eine gültige Postleitzahl an.',
  city: 'Bitte geben Sie eine gültige Stadt an.',
  street: 'Bitte geben Sie eine gültige Strasse an.',
  name: 'Bitte geben Sie nur Buchstaben an.',
  phone: 'Bitte geben Sie nur Ziffern an (Sonderzeichen erlaubt).',
  email: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
  account_owner: 'Bitte geben Sie einen gültigen Namen an.',
  iban: 'Bitte geben Sie eine gültige IBAN-Nummer an.',
  market_identifier: 'Bitte geben Sie eine gültige ID an.',
  // meter_identifier: 'Bitte geben Sie eine gültige Zählernummer an.',

  // Order Step 1
  no_operators_address: 'Diese Lieferadresse ist leider nicht korrekt. Bitte überprüfen Sie Ihre Angaben.',
  'order_dialog_message_default': 'Oh! Das hat leider nicht geklappt.',
  'order_dialog_description_default': 'Irgendwo ist irgendwas schiefgelaufen. Bitte versuchen Sie es noch einmal.',
  'order_dialog_message_invalid-address': 'Eine oder mehrere Ihrer Lieferadressen ist leider nicht korrekt.',
  'order_dialog_description_invalid-address': 'Bitte überprüfen Sie Ihre Angaben.',
  'order_dialog_message_no-operators': 'Die von Ihnen angefragte Lieferstelle kann von Voltego nicht beliefert werden!',
  'order_dialog_description_no-operators': 'Nehmen Sie bitte Kontakt zu uns auf. 02151 447 46 45',
  'order_dialog_message_no-tariffs': 'Die von Ihnen angefragte Lieferstelle kann von Voltego nicht beliefert werden!',
  'order_dialog_description_no-tariffs': 'Nehmen Sie bitte Kontakt zu uns auf. 02151 447 46 45',

  // Order Done
  'order_dialog_message_success': 'Wir freuen uns auf Sie.',
  'order_dialog_description_success': 'Eine gute Entscheidung, dass Sie zu Voltego wechseln möchten. Ihren digitalen Stromliefervertrag, nebst Anlagen, erhalten Sie per E-Mail.',
  // 'order_dialog_message_failed-soft': 'Nehmen Sie bitte Kontakt zu uns auf. 02151 447 46 45',
  // 'order_dialog_description_failed-soft': 'Anscheinend gibt es noch Klärungsbedarf von unserer Seite. Wenn es Ihnen recht ist, wird Voltego Sie in Kürze kontaktieren.',
  'order_dialog_message_failed': 'Danke für Ihr Interesse.',
  'order_dialog_description_failed': 'Aber anscheinend sind Ihrerseits nicht alle Voraussetzungen für eine Zusammenarbeit mit Voltego erfüllt. Wenn es Ihnen recht ist, wird Voltego Sie in Kürze kontaktieren.',
}
